import { render, staticRenderFns } from "./PreQuestionnaire.vue?vue&type=template&id=601780d4&"
import script from "./PreQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./PreQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports